import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';
import { PictureCardItem } from '../../models/picture-card-item';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-picture-card',
  templateUrl: './picture-card.component.html',
  styleUrls: ['./picture-card.component.scss']
})
export class PictureCardComponent implements OnInit, OnDestroy {
  _cards: Array<PictureCardItem>;
  options = {
    key: environment.froalaKey,
    placeholderText: 'Edit Your Content Here! Don\'t leave this blank or else nothing will show up on your website.',
    charCounterCount: true,
    toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'underline', '|', 'insertImage', 'strikeThrough', 'outdent', 'indent', 'clearFormatting', 'insertLink', 'emoticons', 'html'],
    toolbarButtonsXS: ['undo', 'redo', '-', 'bold', 'italic', 'underline'],
    htmlExecuteScripts: false,
    htmlRemoveTags: [],
    pasteDeniedAttrs: [],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'onclick'],
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'script', 'style'],
  }
  private _dragulaSub: Subscription
  @Output() cardsChange = new EventEmitter<any[]>();
  @Output() onSave = new EventEmitter<any[]>();
  @Input()
  get cards() { return this._cards };
  set cards(value: any[]) {
    this._cards = value || [];
    this.cardsChange.emit(this._cards);
  };

  constructor(
    public dragulaService: DragulaService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    if (!this._cards) {
      this._cards = [];
    }
    this._dragulaSub = this.dragulaService.dropModel.subscribe(domStuff => this.save());
  }

  ngOnDestroy() {
    try {
      if (this.dragulaService) {
        this.dragulaService.destroy('picture-card-bag');
      }
      if (this._dragulaSub && !this._dragulaSub.closed) {
        this._dragulaSub.unsubscribe();
      }
    }
    catch (err) {
      console.warn('ngOnDestroy error caught:', err);
    }
  }

  save() {
    this.cards = this._cards;
    this.onSave.emit(this._cards);
  }

  removeCard(index) {
    if (confirm('Are you sure?')) {
      this._cards.splice(index, 1);
    }
  }

  addCard() {
    if (typeof this._cards === "undefined") {
      this._cards = [];
    }
    this._cards.push(new PictureCardItem('body', 'imageUrl'));
  }

  displayCount(str: string) {
    if (!str) return 40
    return 40 - str.length;
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/components/picture-card/picture-card.component.ts